import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const requestExample: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/payments',
    },
    curl:
        `curl --location \\
        --request GET '<YOUR SERVER>/api/payments?lowerAmount=100&upperAmount=1000' \\
        --header 'Authorization: Bearer <TOKEN>'`,
    };

const response: Json = {
    title: 'RESPONSE',
    json: {
        "totalCount": 1,
        "pageNumber": 1,
        "pageSize": 100,
        "results": [
            {
                "id": 4,
                "date": "2025-09-13T14:54:21.000+00:00",
                "soNum": "10035",
                "methodName": "Cash",
                "amount": "220",
                "customerName": "Garrett Gardner",
                "status": "POSTED"
            }
        ],
        "totalPages": 1
    },
};

const data: RequestDefinitionData = {
    id: 'search-payment',
    title: 'Search a payment',
    description: 'Search the Payment with the specified parameters.',
    endpoint: {
        verb: 'GET',
        path: '/api/payments',
        tooltip: 'Search a payment',
    },
    attributes: [],
    requestObject: requestExample,
    responseObject: response,
    queryParameters: [
        {
            name: 'pageNumber',
            type: 'integer',
            description: 'Page number for paginated results. Must be greater than 0 (default: 1).',
            optional: true,
        },
        {
            name: 'pageSize',
            type: 'integer',
            description: 'Number of results per page. Must be greater than 0 (default: 100).',
            optional: true,
        },
        {
            name: 'lowerAmount',
            type: 'number',
            description: 'Minimum payment amount to filter results.',
            optional: true,
        },
        {
            name: 'upperAmount',
            type: 'number',
            description: 'Maximum payment amount to filter results.',
            optional: true,
        },
        {
            name: 'customerId',
            type: 'integer',
            description: 'Filter payments by customer ID.',
            optional: true,
        },
        {
            name: 'startDate',
            type: 'date',
            description: 'Start date for payment search range (ISO 8601 format).',
            optional: true,
        },
        {
            name: 'endDate',
            type: 'date',
            description: 'End date for payment search range (ISO 8601 format).',
            optional: true,
        },
        {
            name: 'posted',
            type: 'integer',
            description: 'Filter by posted status.',
            optional: true,
        },
        {
            name: 'soNumber',
            type: 'string',
            description: 'Sales order number to search for.',
            optional: true,
        },
        {
            name: 'type',
            type: 'integer',
            description: 'Payment type ID to filter results.',
            optional: true,
        }
    ],
};

export default data;
